
import React from "react";
import CollegeSearchModule from "@/components/college-search/CollegeSearchModule";
import { GraduationCap } from "lucide-react";

const CollegeSearch: React.FC = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
      {/* Hero Header */}
      <div className="dashboard-hero rounded-2xl p-6 md:p-8">
        <div className="flex items-center gap-3 mb-2">
          <GraduationCap className="h-8 w-8 text-secondary" />
          <span className="text-secondary font-bold text-sm uppercase tracking-wider">Find Your Fit</span>
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-black text-white uppercase tracking-tight">
          College Search
        </h1>
        <p className="text-slate-300 mt-2 text-lg max-w-3xl">
          Explore thousands of colleges and universities. Filter by division, location, academics, and more to find your perfect match.
        </p>
      </div>
      
      <CollegeSearchModule />
    </div>
  );
};

export default CollegeSearch;
